import { Portal } from "@radix-ui/react-portal";

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@repo/ui/components/ui/navigation-menu";
import type { Header as HeaderType, NavigationItem } from "@repo/ui/types/cms/common";

import Benefits from "./Benefits";
import Destinations from "./Destinations";
import Profile from "./Profile";
import Reservations from "./Reservations";

const triggerClass =
  "text-sm xl:text-base p-1 font-normal text-brand-blue cursor-pointer !bg-transparent hover:text-brand-blue data-[state=open]:text-brand-blue border-b border-transparent rounded-none data-[state=open]:border-b data-[state=open]:border-brand-blue";

const itemClass = "relative";

interface DesktopMenuProps {
  header: HeaderType;
}

export default function DesktopMenu({ header }: Readonly<DesktopMenuProps>) {
  const { navigationItems } = header;

  function resolveMenuContent(menu: NavigationItem) {
    switch (menu.globalheadertab[0]?.name) {
      case "Destinations":
        return (
          <Destinations
            linkedItems={menu.linked_items || []}
            title={menu.title}
            subtitle={menu.subtitle}
          />
        );
      case "Reservation":
        return <Reservations linkedItems={menu.linked_items || []} title={menu.title} />;
      case "Benefits":
        return <Benefits linkedItems={menu.linked_items || []} title={menu.title} />;
      case "TripInformation":
        return (
          <Profile
            linkedItems={menu.linked_items || []}
            title={menu.title}
            subtitle={menu.subtitle}
          />
        );
      default:
        return (
          <div className="p-4 text-sm text-gray-600" data-testid="desktop-menu-empty-section">
            No content available for {menu.name}
          </div>
        );
    }
  }

  return (
    <NavigationMenu data-testid="desktop-menu-navigation">
      <NavigationMenuList className="flex gap-4" data-testid="desktop-menu-list">
        {navigationItems.map((menu: NavigationItem) => (
          <NavigationMenuItem
            key={menu.name}
            className={`${itemClass}`}
            data-testid="desktop-menu-item"
          >
            <NavigationMenuTrigger className={triggerClass} data-testid="desktop-menu-trigger-btn">
              {menu.name}
            </NavigationMenuTrigger>
            <NavigationMenuContent className="!hidden" data-testid="desktop-menu-content-section">
              <Portal asChild>
                <div
                  className="fixed top-18 z-50 shadow-lg bg-white w-full"
                  data-testid="desktop-menu-portal-section"
                >
                  {resolveMenuContent(menu)}
                </div>
              </Portal>
            </NavigationMenuContent>
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
